// DS: i5.3
import React from 'react';
import IconWrap from '../../IconWrap';
const FavStar = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M9.263 1.384A.855.855 0 008.56 1H7.415l-.103.007a.878.878 0 00-.655.47L5.235 4.133l-3.165.472-.108.023a.919.919 0 00-.607.625l-.309 1.008-.03.122c-.058.33.042.672.272.901l2.236 2.233L3 12.655l-.013.127a1 1 0 00.39.851l.944.692.1.064c.243.13.53.132.775 0l2.807-1.516 2.863 1.53.108.048a.813.813 0 00.77-.118l.915-.682.09-.079c.23-.223.337-.565.28-.9l-.546-3.154 2.228-2.225.081-.093c.2-.26.262-.619.157-.945l-.32-.992-.043-.11a.888.888 0 00-.668-.525l-3.174-.473L9.32 1.478l-.057-.094zM7.925 3h.14L9.68 6.015l3.32.492-2.401 2.385.625 3.596-.015.012-3.202-1.7-3.145 1.688-.042-.03.599-3.572L3 6.486l3.313-.491L7.925 3z"
    })));
FavStar.displayName = 'FavStar';
export default FavStar;
